export class Overlay {
    constructor(scrollManager) {
        this.scrollManager = scrollManager;
        this.container = document.getElementById('sections-container');
        this.themeSelector = document.getElementById('theme-selector');
        this.btnPrev = document.getElementById('nav-prev');
        this.btnNext = document.getElementById('nav-next');
        this.init();
    }

    async init() {
        await this.generateSections();

        // Check if world is already ready
        if (this.scrollManager.world.sections && this.scrollManager.world.sections.length > 0) {
            this.setupNavigation();
        } else {
            // Wait for world-ready event
            window.addEventListener('world-ready', () => {
                this.setupNavigation();
            });
        }

        // Listen for updates (Deferred Loading)
        window.addEventListener('world-updated', () => {
            this.setupNavigation();
        });
    }

    setupNavigation() {
        if (!this.scrollManager.world.sections) return;

        // 1. Setup Top Control Bar
        const menuBtn = document.getElementById('nav-menu-btn');
        const prevBtn = document.getElementById('nav-prev-btn');
        const nextBtn = document.getElementById('nav-next-btn');
        const fullMenu = document.getElementById('full-menu-overlay');
        const closeMenuBtn = document.getElementById('close-full-menu');
        const menuGrid = document.getElementById('full-menu-grid');

        // 1. Setup Static Listeners (Only once)
        if (!this.listenersAttached) {
            // FIX: Prevent clicks on the ENTIRE Nav Bar from reaching the 3D world
            const mainNav = document.getElementById('main-nav');
            if (mainNav) {
                mainNav.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }

            // Exit Button Confirmation
            const exitBtn = document.querySelector('.exit-btn');
            if (exitBtn) {
                exitBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (confirm("Voulez-vous quitter l'expérience et retourner sur le site Talosi ?")) {
                        window.location.href = exitBtn.href;
                    }
                });
            }

            // Toggle Full Menu
            menuBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // FIX: Prevent click from passing to 3D World
                fullMenu.classList.add('active');
                document.body.classList.add('menu-open');
            });

            // Prevent clicks on the menu from reaching the 3D world
            fullMenu.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            closeMenuBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // Also for close button
                fullMenu.classList.remove('active');
                document.body.classList.remove('menu-open');
            });

            // Navigation Arrows
            prevBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // FIX
                this.scrollManager.jumpToPreviousSection();

                // If modal is open, switch to previous section modal
                const openModal = document.querySelector('.modal-overlay[style*="display: flex"]');
                if (openModal && this.activeSectionIndex > 0) {
                    const sections = this.scrollManager.world.sections;
                    const nextSection = sections[this.activeSectionIndex - 1];
                    if (nextSection) {
                        openModal.style.display = 'none';
                        window.dispatchEvent(new CustomEvent('open-section-modal', {
                            detail: { sectionId: nextSection.id }
                        }));
                    }
                }
            });

            nextBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // FIX
                this.scrollManager.jumpToNextSection();

                // If modal is open, switch to next section modal
                const openModal = document.querySelector('.modal-overlay[style*="display: flex"]');
                const sections = this.scrollManager.world.sections;
                if (openModal && this.activeSectionIndex < sections.length - 1) {
                    const nextSection = sections[this.activeSectionIndex + 1];
                    if (nextSection) {
                        openModal.style.display = 'none';
                        window.dispatchEvent(new CustomEvent('open-section-modal', {
                            detail: { sectionId: nextSection.id }
                        }));
                    }
                }
            });

            // 3. Update State on Scroll
            window.addEventListener('scroll', () => {
                this.updateNavState();
            });

            this.listenersAttached = true;
        }

        // Populate Full Menu (Dynamic)
        menuGrid.innerHTML = '';
        this.scrollManager.world.sections.forEach((section, index) => {
            const item = document.createElement('div');
            item.className = 'menu-item';
            // Stagger animation: 0.05s delay per item
            item.style.animationDelay = `${index * 0.05}s`;

            // Set custom property for hover color
            item.style.setProperty('--hover-color', section.color ? '#' + section.color.toString(16).padStart(6, '0') : '#ffffff');

            const number = document.createElement('span');
            number.className = 'menu-item-number';
            number.textContent = (index + 1).toString().padStart(2, '0');

            const title = document.createElement('span');
            title.className = 'menu-item-title';
            title.textContent = section.title;

            item.appendChild(number);
            item.appendChild(title);

            item.addEventListener('click', () => {
                this.scrollManager.scrollToZ(-section.startZ);
                fullMenu.classList.remove('active');
                document.body.classList.remove('menu-open');

                // Check if any modal is open
                const openModal = document.querySelector('.modal-overlay[style*="display: flex"]');
                if (openModal) {
                    // Switch modal immediately
                    // Close current
                    openModal.style.display = 'none';
                    // Open new
                    window.dispatchEvent(new CustomEvent('open-section-modal', {
                        detail: { sectionId: section.id }
                    }));
                }
            });

            menuGrid.appendChild(item);
        });

        // Initial check
        this.updateNavState();

        // 4. Check for Deep Link to Modal
        const urlParams = new URLSearchParams(window.location.search);
        const shouldOpen = urlParams.get('open') === 'true';
        const hash = window.location.hash.replace('#', '');

        if (shouldOpen && hash) {
            // Wait a bit for everything to settle
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('open-section-modal', {
                    detail: { sectionId: hash }
                }));
            }, 500);
        }

        // 5. Title Click Listener (Only attach once)
        const navTitle = document.getElementById('nav-current-title');
        if (navTitle && !this.titleListenerAttached) {
            navTitle.style.cursor = 'pointer'; // Visual cue
            navTitle.title = "Ouvrir la section";

            navTitle.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.activeSectionIndex !== undefined && this.activeSectionIndex !== -1) {
                    const section = this.scrollManager.world.sections[this.activeSectionIndex];
                    if (section) {
                        window.dispatchEvent(new CustomEvent('open-section-modal', {
                            detail: { sectionId: section.id }
                        }));
                    }
                }
            });
            this.titleListenerAttached = true;
        }
    }

    updateNavState() {
        // Determine current section based on camera Z
        const currentZ = this.scrollManager.world.camera.position.z;
        let currentSectionIndex = -1;

        const sections = this.scrollManager.world.sections;
        if (!sections) return;

        // Sync Top Bar Title
        let activeIndex = 0;
        for (let i = 0; i < sections.length; i++) {
            const start = -sections[i].startZ;
            if (currentZ <= start + 2) { // +2 buffer for transition
                activeIndex = i;
            }
        }

        // Store active index for click interactions
        this.activeSectionIndex = activeIndex;

        const navTitle = document.getElementById('nav-current-title');
        if (navTitle && sections[activeIndex]) {
            const currentTitle = sections[activeIndex].title;
            if (navTitle.textContent !== currentTitle) {
                navTitle.textContent = currentTitle;
            }
        }

        // Update Arrows Visibility
        const prevBtn = document.getElementById('nav-prev-btn');
        const nextBtn = document.getElementById('nav-next-btn');

        if (prevBtn) {
            prevBtn.style.opacity = activeIndex === 0 ? '0.3' : '1';
            prevBtn.style.pointerEvents = activeIndex === 0 ? 'none' : 'auto';
        }

        if (nextBtn) {
            nextBtn.style.opacity = activeIndex === sections.length - 1 ? '0.3' : '1';
            nextBtn.style.pointerEvents = activeIndex === sections.length - 1 ? 'none' : 'auto';
        }
    }

    async generateSections() {
        try {
            const response = await fetch('data.json');
            const data = await response.json();

            this.container.innerHTML = '';

            // Create Modals for each section
            data.sections.forEach(section => {
                const modal = document.createElement('div');
                modal.id = `modal-${section.id}`;
                modal.className = 'modal-overlay';
                modal.style.display = 'none'; // Hidden by default

                // Header with Thumbnail if available
                let headerHTML = `
                    <div class="section-header">
                        <h1 style="color: ${section.color}">${section.title}</h1>
                        <p>${section.description}</p>
                    </div>
                `;

                if (section.assets && section.assets.thumbnail) {
                    headerHTML = `
                        <div class="section-header with-thumbnail">
                            <img data-src="${section.assets.thumbnail}" alt="${section.title} Thumbnail" class="main-thumbnail lazy-load">
                            <div class="header-text">
                                <h1 style="color: ${section.color}">${section.title}</h1>
                                <p>${section.description}</p>
                            </div>
                        </div>
                    `;
                }

                // Vertical Stack Layout
                let stackHTML = `<div class="vertical-stack">`;

                if (section.assets) {
                    // 1. Logos
                    stackHTML += `<div class="stack-block logo-block">
                        <h3>Logos</h3>
                        <div class="block-content">`;
                    if (section.assets.logos && section.assets.logos.length > 0) {
                        section.assets.logos.forEach(logo => {
                            // logo is now { path, title }
                            if (logo.path) {
                                const ext = logo.path.split('.').pop().toLowerCase();
                                stackHTML += `
                                    <div class="asset-item">
                                        <h4>${logo.title || 'Logo'}</h4>
                                        <div class="img-wrapper">
                                            <a href="${logo.path}" target="_blank" title="Ouvrir le lien">
                                                <img data-src="${logo.path}" alt="Logo" class="dynamic-meta-img lazy-load">
                                            </a>
                                        </div>
                                        <p class="asset-format">Format .${ext} <span class="dims">(-)</span></p>
                                        <div class="asset-actions">
                                            <a href="${logo.path}" download class="btn-download">Télécharger</a>
                                            <button class="btn-copy" data-link="${logo.path}" title="Copier le lien">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>`;
                            }
                        });
                    } else {
                        stackHTML += `<p class="empty-msg">No logos</p>`;
                    }
                    stackHTML += `</div></div>`;

                    // 2. Videos
                    stackHTML += `<div class="stack-block video-block">
                        <h3>Videos</h3>
                        <div class="block-content">`;
                    if (section.assets.videos && section.assets.videos.length > 0) {
                        section.assets.videos.forEach(video => {
                            // video is { type, id, title, downloadLink }
                            stackHTML += `<div class="asset-item video-asset">`;
                            if (video.title) {
                                stackHTML += `<h4>${video.title}</h4>`;
                            }

                            if (video.type === 'youtube') {
                                stackHTML += `<div class="video-wrapper"><iframe width="100%" height="200" src="https://www.youtube.com/embed/${video.id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; compute-pressure" allowfullscreen></iframe></div>`;
                            } else {
                                if (typeof video === 'string') {
                                    stackHTML += `<div class="video-wrapper"><video src="${video}" controls muted loop></video></div>`;
                                }
                            }

                            if (video.downloadLink) {
                                const isLocal = !video.downloadLink.startsWith('http');
                                stackHTML += `<div class="asset-actions">
                                    <a href="${video.downloadLink}" ${isLocal ? 'download' : 'target="_blank"'} class="btn-download">Télécharger</a>
                                    <button class="btn-copy" data-link="${video.downloadLink}" title="Copier le lien">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                        </svg>
                                    </button>
                                </div>`;
                            }
                            stackHTML += `</div>`;
                        });
                    } else {
                        stackHTML += `<p class="empty-msg">No videos</p>`;
                    }
                    stackHTML += `</div></div>`;

                    // 3. Wallpapers (Fonds d'écrans)
                    stackHTML += `<div class="stack-block wallpaper-block">
                        <h3>Fonds d'écrans</h3>
                        <div class="block-content">`;
                    if (section.assets.wallpapers && section.assets.wallpapers.length > 0) {
                        section.assets.wallpapers.forEach(wallpaper => {
                            // wallpaper is { path, title }
                            if (wallpaper.path) {
                                const ext = wallpaper.path.split('.').pop().toLowerCase();
                                stackHTML += `
                                    <div class="asset-item">
                                        <h4>${wallpaper.title || 'Wallpaper'}</h4>
                                        <div class="img-wrapper">
                                            <a href="${wallpaper.path}" target="_blank" title="Ouvrir le lien">
                                                <img data-src="${wallpaper.path}" alt="Wallpaper" class="dynamic-meta-img lazy-load">
                                            </a>
                                        </div>
                                        <p class="asset-format">Format .${ext} <span class="dims">(-)</span></p>
                                        <div class="asset-actions">
                                            <a href="${wallpaper.path}" download class="btn-download">Télécharger</a>
                                            <button class="btn-copy" data-link="${wallpaper.path}" title="Copier le lien">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>`;
                            }
                        });
                    } else {
                        stackHTML += `<p class="empty-msg">No wallpapers</p>`;
                    }
                    stackHTML += `</div></div>`;

                    // 4. Signature
                    stackHTML += `<div class="stack-block signature-block">
                        <h3>Signature</h3>
                        <div class="block-content">`;
                    if (section.assets.signature) {
                        // signature is { previewLink, downloadLink }
                        const sig = section.assets.signature;
                        const isLocal = (link) => !link.startsWith('http');
                        if (sig.previewLink) {
                            stackHTML += `
                                <div class="asset-item signature-asset">
                                    <h4>Signature</h4>
                                    <div class="img-wrapper">
                                        <a href="${sig.downloadLink || sig.previewLink}" target="_blank" title="Ouvrir le lien">
                                            <img data-src="${sig.previewLink}" alt="Signature" class="dynamic-meta-img lazy-load">
                                        </a>
                                    </div>
                                    <div class="asset-actions">
                                        ${sig.downloadLink ? `<a href="${sig.downloadLink}" ${isLocal(sig.downloadLink) ? 'download' : 'target="_blank"'} class="btn-download">Télécharger</a>` : ''}
                                        ${sig.downloadLink ? `<button class="btn-copy" data-link="${sig.downloadLink}" title="Copier le lien">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                            </svg>
                                        </button>` : ''}
                                    </div>
                                </div>`;
                        }
                    } else {
                        stackHTML += `<p class="empty-msg">No signature</p>`;
                    }
                    stackHTML += `</div></div>`;
                }

                stackHTML += `</div>`; // Close stack

                // Removed 'glass-panel' class for solid background
                modal.innerHTML = `
                    <div class="modal-content wide-panel solid-panel">
                        <div class="sticky-header-wrapper">
                            <button class="close-modal">&times;</button>
                            <button class="share-section-btn" title="Partager cette section">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="18" cy="5" r="3"></circle>
                                    <circle cx="6" cy="12" r="3"></circle>
                                    <circle cx="18" cy="19" r="3"></circle>
                                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                                </svg>
                            </button>
                            ${headerHTML}
                        </div>
                        ${stackHTML}
                    </div>
                `;

                // Calculate Dimensions Logic
                modal.querySelectorAll('.dynamic-meta-img').forEach(img => {
                    const updateDims = () => {
                        if (img.naturalWidth && img.naturalHeight) {
                            const container = img.closest('.asset-item');
                            const dimSpan = container.querySelector('.dims');
                            if (dimSpan) {
                                dimSpan.textContent = `(${img.naturalWidth}x${img.naturalHeight})`;
                            }
                        }
                    };

                    // Use addEventListener to persist across src changes
                    img.addEventListener('load', updateDims);

                    if (img.complete) {
                        updateDims();
                    }
                });

                // Share Section Button Logic
                const shareBtn = modal.querySelector('.share-section-btn');
                if (shareBtn) {
                    shareBtn.addEventListener('click', () => {
                        const url = `${window.location.origin}/?open=true#${section.id}`;
                        navigator.clipboard.writeText(url).then(() => {
                            const originalHTML = shareBtn.innerHTML;
                            shareBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
                            shareBtn.classList.add('copied');
                            setTimeout(() => {
                                shareBtn.innerHTML = originalHTML;
                                shareBtn.classList.remove('copied');
                            }, 2000);
                        });
                    });
                }

                // Copy Button Logic (Assets)
                modal.querySelectorAll('.btn-copy').forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        const link = btn.dataset.link;
                        // Resolve absolute URL if local
                        const absoluteLink = link.startsWith('http') ? link : new URL(link, window.location.href).href;

                        navigator.clipboard.writeText(absoluteLink).then(() => {
                            // Visual feedback
                            const originalHTML = btn.innerHTML;
                            btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
                            btn.classList.add('copied');
                            setTimeout(() => {
                                btn.innerHTML = originalHTML;
                                btn.classList.remove('copied');
                            }, 2000);
                        });
                    });
                });

                // Close button logic
                const close = () => {
                    modal.style.display = 'none';
                    document.getElementById('canvas-container').style.display = 'block';

                    // Restore UI Buttons
                    const exitBtn = document.querySelector('.exit-btn');
                    const infoBtn = document.querySelector('.top-right-container');
                    if (exitBtn) exitBtn.style.display = 'flex';
                    if (infoBtn) infoBtn.style.display = 'block';

                    if (window.app && window.app.world) window.app.world.resume();
                    // Clear Hash
                    window.history.pushState(null, null, ' ');
                };

                modal.querySelector('.close-modal').addEventListener('click', (e) => {
                    e.stopPropagation(); // FIX: Prevent click from reaching 3D World
                    close();
                });

                // FIX: Stop clicks inside the modal content from passing through to the 3D world
                // (e.g. clicking text shouldn't rotate camera or click wall)
                const contentBox = modal.querySelector('.modal-content');
                if (contentBox) {
                    contentBox.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }

                // Close on click outside
                modal.addEventListener('click', (e) => {
                    if (e.target === modal) close();
                });

                this.container.appendChild(modal);
            });

            // Listen for open event
            window.addEventListener('open-section-modal', (e) => {
                const sectionId = e.detail.sectionId;
                const modal = document.getElementById(`modal-${sectionId}`);
                if (modal) {
                    modal.style.display = 'flex';
                    // Force Reflow
                    void modal.offsetHeight;
                    document.getElementById('canvas-container').style.display = 'none';
                    if (window.app && window.app.world) window.app.world.pause();

                    // Lazy Load Images
                    const lazyImages = modal.querySelectorAll('img.lazy-load');
                    lazyImages.forEach(img => {
                        if (img.dataset.src) {
                            img.src = img.dataset.src;
                            img.classList.remove('lazy-load');
                        }
                    });

                    // Update URL Hash for Deep Linking
                    window.history.pushState(null, null, `#${sectionId}`);

                    // Hide UI Buttons
                    const exitBtn = document.querySelector('.exit-btn');
                    const infoBtn = document.querySelector('.top-right-container');
                    if (exitBtn) exitBtn.style.display = 'none';
                    if (infoBtn) infoBtn.style.display = 'none';
                }
            });

            // Global Escape Key Listener
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    document.querySelectorAll('.modal-overlay').forEach(modal => {
                        if (modal.style.display === 'flex') {
                            modal.style.display = 'none';
                            document.getElementById('canvas-container').style.display = 'block';
                            if (window.app && window.app.world) window.app.world.resume();
                            // Clear Hash
                            window.history.pushState(null, null, ' ');

                            // Restore UI Buttons
                            const exitBtn = document.querySelector('.exit-btn');
                            const infoBtn = document.querySelector('.top-right-container');
                            if (exitBtn) exitBtn.style.display = 'flex';
                            if (infoBtn) infoBtn.style.display = 'block';
                        }
                    });
                }
            });

            // Update the close function defined inside the loop to also clear hash
            // Since that function is defined in scope above (line 406), I need to modify THE LOOP body or make the listener global.
            // The listener at line 422 is outside the loop.
            // The close button is inside the loop.
            // Let's modify the close button handler inside the loop (via separate edit if needed, or assume this block covers it?)
            // This replace_file_content targets line 421-432 which is the LISTENER.
            // The close button logic is earlier (lines 406-411).
            // I should also update the close logic.
            // Let's do the listener first here.

            // Global Escape Key Listener


            window.dispatchEvent(new CustomEvent('dom-ready'));

        } catch (error) {
            console.error('Error generating DOM sections:', error);
        }
    }
}
